import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { RelatorioEmailPdfDataResponse } from "../typings/index";
import { ListarFiltroEmailQuery } from "core/features/relatorios/typings";

export function useRelatorioEmailPdf(filtro: ListarFiltroEmailQuery, enabled?: boolean) {
  return useQuery<RelatorioEmailPdfDataResponse, AxiosError>(
    [`/v1/relatorios/emails/pdf`, filtro],
    async () => {
      const { data } = await http.get<RelatorioEmailPdfDataResponse>(
        "/v1/relatorios/emails/pdf",
        { params: filtro }
      );

      return data;
    }, {
      enabled,
    }
  );
}
